/**
 * AutoSettings - автоматически генерирует UI настроек из schema.fields
 */
import React from 'react';
import SettingsGroup from './SettingsGroup';
import FieldRenderer from './FieldRenderer';

export default function AutoSettings({
  schema,
  data = {},
  onChange,
  allSections,
  allPages,
  projectId,
}) {
  if (!schema?.fields) {
    return null;
  }

  const updateField = (key, value) => {
    onChange({ ...data, [key]: value });
  };

  // Check if field or group should be visible (supports visible function)
  const isVisible = (item) => {
    if (typeof item.visible === 'function') {
      return item.visible(data);
    }
    return true;
  };

  // Check if group should be shown (group-level visibility or has visible fields)
  const isGroupVisible = (group) => {
    // First check group-level visibility
    if (!isVisible(group)) return false;
    // Then check if has any visible fields
    return group.fields.some(isVisible);
  };

  return (
    <div className="space-y-6">
      {schema.fields.map((group, groupIndex) => {
        if (!isGroupVisible(group)) return null;

        return (
          <SettingsGroup key={group.group || groupIndex} title={group.group}>
            <div className="space-y-4">
              {group.fields.map(field => {
                if (!isVisible(field)) return null;

                return (
                  <FieldRenderer
                    key={field.key}
                    field={field}
                    value={data[field.key]}
                    onChange={(v) => updateField(field.key, v)}
                    allSections={allSections}
                    allPages={allPages}
                    projectId={projectId}
                  />
                );
              })}
            </div>
          </SettingsGroup>
        );
      })}
    </div>
  );
}
